<template>
  <div class="hello">
    <div class="topOperation">
      <div></div>
      <div class="top-right">
        <!-- <button class="search" @click="dialogVisible = true" v-if="this.errorLength<10">校验入库</button> -->
        <el-button class="exportButton" @click="putStorage">强制入库</el-button>
        <el-button class="exportButton" @click="exportHandle" :loading="btnLoading" :disabled="tableData == [] || tableData.length <= 0">导出勘误表</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/customerList' }">花名册</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/operationRecord' }">导入记录</el-breadcrumb-item>
          <el-breadcrumb-item>花名册勘误</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="customerRosterTable3">
        <el-table :data="tableData" :max-height="tableHeight-180" border style="width: 99%" v-loading="listLoading" @selection-change="handleSelectionChange" @cell-dblclick="showEditInput" :lazy="true" :cell-style="columnStyle">
          <el-table-column align="center" type="selection" width="40"></el-table-column>
          <el-table-column align="center" fixed label="序号" width="50">
            <template slot-scope="{$index}">
              <span>{{(Number(currpage) - 1) * Number(pagecount) + Number($index) + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" fixed prop="StrFileNo" label="档案号" width="150">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <!-- {{ scope.row.StrFileNo }} -->
                <el-input v-focus v-model="qdata.StrFileNo" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <!-- <div
                v-if="!scope.row.isEdit || scope.row.EditName!=scope.column.property"
              >{{ scope.row.StrFileNo }}</div> -->
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="scope.row.showError.indexOf('StrFileNo') != -1">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('StrFileNo') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{ scope.row.StrFileNo ? scope.row.StrFileNo : "-" }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.StrFileNo }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" fixed prop="StrEmpName" label="姓名" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-focus v-model="qdata.StrEmpName" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <!-- <div
                v-if="!scope.row.isEdit || scope.row.EditName!=scope.column.property"
              >{{ scope.row.StrEmpName }}</div> -->
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="scope.row.showError.indexOf('StrEmpName') != -1">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('StrEmpName') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{ scope.row.StrEmpName ? scope.row.StrEmpName : "-" }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.StrEmpName }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="reason" fixed label="错误原因" width="100">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.reason" placement="bottom" effect="light">
                <img src="../../assets/employee/images/warning.png" alt="" style="width: 24px" />
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrSrvCent" label="服务中心" width="150">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-select v-model="scope.row.StrSrvCent" slot="prepend" placeholder="请选择" filterable @change="chooseEmpInfo" @blur="chooseEmpInfo2(scope.row, scope.column)">
                  <el-option v-for="(item, index) in SrvCent" :value="item" :key="index"></el-option>
                </el-select>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrSrvCent }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrBlCmp" label="劳动合同签署公司全称" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrBlCmp" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrBlCmp }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrObjName" label="项目名称" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-select v-model="scope.row.StrObjName" slot="prepend" placeholder="请选择" filterable @change="chooseEmpInfo" @blur="chooseEmpInfo2(scope.row, scope.column)">
                  <el-option v-for="(item, index) in objList" :key="index" :label="item.StrObjName" :value="item.StrObjName">
                  </el-option>
                </el-select>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrObjName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="subProject" label="子项目" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.subProject" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.subProject }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrProjectType" label="项目类别" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-select v-model="scope.row.StrProjectType" slot="prepend" placeholder="请选择" filterable @change="chooseEmpInfo" @blur="chooseEmpInfo2(scope.row, scope.column)">
                  <el-option value="外包"></el-option>
                  <el-option value="代理"></el-option>
                </el-select>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrProjectType }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrObjInstName" label="业务立项部门" width="150">
            <!-- <template slot-scope="scope">
              <div
                class="tableEditInput"
                v-if="scope.row.isEdit && scope.row.EditName==scope.column.property"
              >
                <el-select
                  v-model="scope.row.StrObjInstName"
                  slot="prepend"
                  placeholder="请选择"
                  filterable
                  @change="chooseEmpInfo"
                  @blur="chooseEmpInfo2(scope.row,scope.column)"
                >
                  <el-option value="合伙人王晶烨"></el-option>
                  <el-option value="合伙人张二狗"></el-option>
                </el-select>
              </div>
              <div
                v-if="!scope.row.isEdit || scope.row.EditName!=scope.column.property"
              >{{ scope.row.StrObjInstName }}</div>
            </template> -->
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrObjInstName" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrObjInstName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrUserName" label="负责客服" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-select v-model="scope.row.StrUserName" slot="prepend" placeholder="请选择" filterable @change="chooseEmpInfo" @blur="chooseEmpInfo2(scope.row, scope.column)">
                  <el-option v-for="(item, index) in subordinateList" :key="index" :label="item.Username" :value="item.Username"></el-option>
                </el-select>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrUserName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrTmpProject" label="自定义项目" width="200">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrTmpProject" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrTmpProject }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrDepName" label="部门" width="130">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrDepName" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrDepName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrJobInf" label="岗位" width="150">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrJobInf" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrJobInf }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrIdCard" label="身份证" width="180">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrIdCard" :id="scope.row.IntExcelLine + scope.column.id" @blur="editIdCard(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="scope.row.showError.indexOf('StrIdCard') != -1">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('StrIdCard') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{ scope.row.StrIdCard ? scope.row.StrIdCard : "-" }}
                    </div>
                  </el-tooltip>
                </div>
                <!-- <div v-if="scope.row.idcardJudge == 'false'">
                  <el-tooltip content="身份证格式不正确" placement="bottom" effect="light">
                    <div class="errorShow">
                      {{ scope.row.StrIdCard ? scope.row.StrIdCard : "-" }}
                    </div>
                  </el-tooltip>
                </div> -->
                <div v-else>{{ scope.row.StrIdCard }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="idcardJudge" label="判定" width="60"></el-table-column>
          <el-table-column align="center" prop="sex" label="性别" width="60"></el-table-column>
          <el-table-column align="center" prop="birth" label="出生年月" width="120"></el-table-column>
          <el-table-column align="center" prop="age" label="年龄" width="60"></el-table-column>
          <el-table-column align="center" prop="StrPolitical" label="政治面貌" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-select v-model="scope.row.StrPolitical" slot="prepend" placeholder="请选择" filterable @change="chooseEmpInfo" @blur="chooseEmpInfo2(scope.row, scope.column)">
                  <el-option value="群众"></el-option>
                  <el-option value="党员"></el-option>
                  <el-option value="团员"></el-option>
                </el-select>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrPolitical }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtIcCareEdate" label="身份证有效终止时间" width="150">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.DtIcCareEdate" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="scope.row.showError.indexOf('DtIcCareEDate') != -1">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('DtIcCareEDate') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{
                        scope.row.DtIcCareEdate ? scope.row.DtIcCareEdate.substring(0, 10) : "-"
                      }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>{{ isNullDate(scope.row.DtIcCareEdate) ? "":scope.row.DtIcCareEdate.substring(0, 10) }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrCityzenType" label="户粮" width="150">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-select v-model="scope.row.StrCityzenType" slot="prepend" placeholder="请选择" filterable @change="chooseEmpInfo" @blur="chooseEmpInfo2(scope.row, scope.column)">
                  <el-option v-for="(item, index) in CityzenType" :value="item" :key="index"></el-option>
                </el-select>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrCityzenType }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrPhoneNum" label="联系方式" width="120">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrPhoneNum" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="
                    scope.row.showError.indexOf('StrPhoneNum') != -1 &&
                    scope.row.judgePhone != 'false'
                  ">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('StrPhoneNum') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{ scope.row.StrPhoneNum ? scope.row.StrPhoneNum : "-" }}
                    </div>
                  </el-tooltip>
                </div>
                <!-- <div v-if="scope.row.judgePhone=='false'">
                  <el-tooltip content="手机号码格式不正确" placement="bottom" effect="light">
                    <div class="errorShow">{{ scope.row.StrPhoneNum ? scope.row.StrPhoneNum : "-"}}</div>
                  </el-tooltip>
                </div> -->
                <div v-else>{{ scope.row.StrPhoneNum }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrContName" label="紧急联系人" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrContName" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrContName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrContTel" label="紧急联系方式" width="120">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrContTel" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="
                    scope.row.showError.indexOf('StrContTel') != -1 &&
                    scope.row.contTelJudge != 'false'
                  ">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('StrContTel') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{ scope.row.StrContTel ? scope.row.StrContTel : "-" }}
                    </div>
                  </el-tooltip>
                </div>
                <!-- <div v-if="scope.row.contTelJudge=='false'">
                  <el-tooltip content="手机号码格式不正确" placement="bottom" effect="light">
                    <div class="errorShow">{{ scope.row.StrContTel ? scope.row.StrContTel : "-"}}</div>
                  </el-tooltip>
                </div> -->
                <div v-else>{{ scope.row.StrContTel }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrNationClass" label="民族" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-select v-model="scope.row.StrNationClass" slot="prepend" placeholder="请选择" filterable @change="chooseEmpInfo" @blur="chooseEmpInfo2(scope.row, scope.column)">
                  <el-option v-for="(item, index) in nationals" :value="item" :key="index"></el-option>
                </el-select>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrNationClass }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrNativePlace" label="籍贯" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrNativePlace" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrNativePlace }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrNativeAddr" label="户籍地址" width="400">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrNativeAddr" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrNativeAddr }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrAddr" label="现住地址" width="350">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrAddr" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <!-- <div
                v-if="!scope.row.isEdit || scope.row.EditName!=scope.column.property"
              >{{ scope.row.StrAddr }}</div> -->
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="scope.row.showError.indexOf('StrAddr') != -1">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('StrAddr') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{ scope.row.StrAddr ? scope.row.StrAddr : "-" }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.StrAddr }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrEduLv" label="教育程度" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-select v-model="scope.row.StrEduLv" slot="prepend" placeholder="请选择" filterable @change="chooseEmpInfo" @blur="chooseEmpInfo2(scope.row, scope.column)">
                  <el-option v-for="(item, index) in eduLv" :value="item" :key="index"></el-option>
                </el-select>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrEduLv }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrInsuranceType" label="参保种类" width="200">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-select v-model="scope.row.StrInsuranceType" slot="prepend" placeholder="请选择" filterable @change="chooseEmpInfo" @blur="chooseEmpInfo2(scope.row, scope.column)">
                  <el-option v-for="(item, index) in InsuranceType" :value="item" :key="index"></el-option>
                </el-select>
              </div>
              <!-- <div
                v-if="!scope.row.isEdit || scope.row.EditName!=scope.column.property"
              >{{ scope.row.StrInsuranceType }}</div> -->
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="scope.row.showError.indexOf('StrInsuranceType') != -1">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('StrInsuranceType') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{
                        scope.row.StrInsuranceType
                          ? scope.row.StrInsuranceType
                          : "-"
                      }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.StrInsuranceType }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtInsuranceDate" label="参保日期" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.DtInsuranceDate" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="scope.row.showError.indexOf('DtInsuranceDate') != -1">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('DtInsuranceDate') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{
                        scope.row.DtInsuranceDate
                          ? scope.row.DtInsuranceDate
                          : "-"
                      }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.DtInsuranceDate  }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrMedicalCard" label="医保卡号" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrMedicalCard" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrMedicalCard }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtEntryBdate" label="用工之日" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.DtEntryBdate" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="scope.row.showError.indexOf('DtEntryBdate') != -1">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('DtEntryBdate') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{
                        scope.row.DtEntryBdate ? scope.row.DtEntryBdate : "-"
                      }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.DtEntryBdate }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrContractType" label="合同（协议）类型" width="150">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-select v-model="scope.row.StrContractType" slot="prepend" placeholder="请选择" filterable @change="chooseEmpInfo" @blur="chooseEmpInfo2(scope.row, scope.column)">
                  <el-option v-for="(item, index) in ContractType" :value="item" :key="index"></el-option>
                </el-select>
              </div>
              <!-- <div
                v-if="!scope.row.isEdit || scope.row.EditName!=scope.column.property"
              >{{ scope.row.StrContractType }}</div> -->
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="scope.row.showError.indexOf('StrContractType') != -1">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('StrContractType') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{
                        scope.row.StrContractType
                          ? scope.row.StrContractType
                          : "-"
                      }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.StrContractType }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="IntContractNum" label="签定合同次数" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input type="number" v-model="qdata.IntContractNum" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <!-- <div
                v-if="!scope.row.isEdit || scope.row.EditName!=scope.column.property"
              >{{ scope.row.IntContractNum }}</div> -->
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="scope.row.showError.indexOf('IntContractNum') != -1">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('IntContractNum') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{
                        scope.row.IntContractNum
                          ? scope.row.IntContractNum
                          : "-"
                      }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.IntContractNum }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrContractBedate" label="签订合同起止时间记录" width="400">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrContractBedate" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <!-- <div
                v-if="!scope.row.isEdit || scope.row.EditName!=scope.column.property"
              >{{ scope.row.StrContractBedate }}</div> -->
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="scope.row.showError.indexOf('StrContractBedate') != -1">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('StrContractBedate') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{
                        scope.row.StrContractBedate
                          ? scope.row.StrContractBedate
                          : "-"
                      }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.StrContractBedate }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtProbationEdate" label="试用期到期日期" width="150">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.DtProbationEdate" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="scope.row.showError.indexOf('DtProbationEdate') != -1">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('DtProbationEdate') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{
                        scope.row.DtProbationEdate
                          ? scope.row.DtProbationEdate
                          : "-"
                      }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.DtProbationEdate }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtContractBtime" label="劳动合同起始时间" width="150">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.DtContractBtime" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="scope.row.showError.indexOf('DtContractBtime') != -1">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('DtContractBtime') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{
                        scope.row.DtContractBtime
                          ? scope.row.DtContractBtime
                          : "-"
                      }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.DtContractBtime }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtContractTime" label="劳动合同到期时间" width="150">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.DtContractTime" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="scope.row.showError.indexOf('DtContractTime') != -1">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('DtContractTime') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{
                        scope.row.DtContractTime
                          ? scope.row.DtContractTime
                          : "-"
                      }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.DtContractTime }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrWorkState" label="在/离职状态" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-select v-model="scope.row.StrWorkState" slot="prepend" placeholder="请选择" filterable @change="chooseEmpInfo" @blur="chooseEmpInfo2(scope.row, scope.column)">
                  <el-option value="在职"></el-option>
                  <el-option value="离职"></el-option>
                  <el-option value="离职转正"></el-option>
                  <el-option value="自离"></el-option>
                </el-select>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrWorkState }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtDepartureDate" label="离职日期" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.DtDepartureDate" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="scope.row.showError.indexOf('DtDepartureDate') != -1">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('DtDepartureDate') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{
                        scope.row.DtDepartureDate
                          ? scope.row.DtDepartureDate
                          : "-"
                      }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.DtDepartureDate }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtRealDepartureDate" label="实际离职日期" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.DtRealDepartureDate" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="
                    scope.row.showError.indexOf('DtRealDepartureDate') != -1
                  ">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('DtRealDepartureDate') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{
                        scope.row.DtRealDepartureDate
                          ? scope.row.DtRealDepartureDate
                          : "-"
                      }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.DtRealDepartureDate }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrBankCard" label="银行卡号" width="200">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrBankCard" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrBankCard }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrBankName" label="银行" width="150">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-select v-model="scope.row.StrBankName" slot="prepend" placeholder="请选择" filterable @change="chooseEmpInfo" @blur="chooseEmpInfo2(scope.row, scope.column)">
                  <el-option v-for="(item, index) in bank" :value="item" :key="index"></el-option>
                </el-select>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrBankName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrWithdrawal" label="是否计提" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-select v-model="scope.row.StrWithdrawal" slot="prepend" placeholder="请选择" filterable @change="chooseEmpInfo" @blur="chooseEmpInfo2(scope.row, scope.column)">
                  <el-option value="是"></el-option>
                  <el-option value="否"></el-option>
                </el-select>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrWithdrawal }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrInCity" label="市内" width="200">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrInCity" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrInCity }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrOutsideCity" label="市外" width="200">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrOutsideCity" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrOutsideCity }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrOther" label="其他情况" width="200">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrOther" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrOther }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrPetype" label="体检类型" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-select v-model="scope.row.StrPetype" slot="prepend" placeholder="请选择" filterable @change="chooseEmpInfo" @blur="chooseEmpInfo2(scope.row, scope.column)">
                  <el-option value="常规体检"></el-option>
                  <el-option value="职业病体检"></el-option>
                  <el-option value="无要求"></el-option>
                </el-select>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrPetype }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrPeres" label="体检结果" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-select v-model="scope.row.StrPeres" slot="prepend" placeholder="请选择" filterable @change="chooseEmpInfo" @blur="chooseEmpInfo2(scope.row, scope.column)">
                  <el-option value="正常"></el-option>
                  <el-option value="异常"></el-option>
                </el-select>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrPeres }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrEmpUsrStatus" label="人员状态" width="150">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-select v-model="scope.row.StrEmpUsrStatus" slot="prepend" placeholder="请选择" filterable @change="chooseEmpInfo" @blur="chooseEmpInfo2(scope.row, scope.column)">
                  <el-option value="调岗"></el-option>
                  <el-option value="再次入职"></el-option>
                </el-select>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrEmpUsrStatus }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtInjuryBdate" label="工伤纠纷发生时间" width="150">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.DtInjuryBdate" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="scope.row.showError.indexOf('DtInjuryBdate') != -1">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('DtInjuryBdate') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{
                        scope.row.DtInjuryBdate ? scope.row.DtInjuryBdate : "-"
                      }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.DtInjuryBdate }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrDisabilityLevel" label="伤残等级" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrDisabilityLevel" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrDisabilityLevel }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtInjuryEdate" label="工伤纠纷结束时间" width="150">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.DtInjuryEdate" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                <div v-if="scope.row.showError.indexOf('DtInjuryEdate') != -1">
                  <el-tooltip :content="
                      scope.row.showError[
                        scope.row.showError.indexOf('DtInjuryEdate') + 1
                      ].reason
                    " placement="bottom" effect="light">
                    <div class="errorShow">
                      {{
                        scope.row.DtInjuryEdate ? scope.row.DtInjuryEdate : "-"
                      }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.DtInjuryEdate }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrBlacklist" label="是否黑名单" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-select v-model="scope.row.StrBlacklist" slot="prepend" placeholder="请选择" filterable @change="chooseEmpInfo" @blur="chooseEmpInfo2(scope.row, scope.column)">
                  <el-option value="是"></el-option>
                  <el-option value="否"></el-option>
                </el-select>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrBlacklist }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrBlacklistReason" label="黑名单原因" width="100">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrBlacklistReason" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrBlacklistReason }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrRemark" label="备注" width="300">
            <template slot-scope="scope">
              <div class="tableEditInput" v-if="
                  scope.row.isEdit &&
                  scope.row.EditName == scope.column.property
                ">
                <el-input v-model="qdata.StrRemark" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)" @keyup.enter.native="$event.target.blur"></el-input>
              </div>
              <div v-if="
                  !scope.row.isEdit ||
                  scope.row.EditName != scope.column.property
                ">
                {{ scope.row.StrRemark }}
              </div>
            </template>
          </el-table-column>
          <template v-for="(item, index) in tableTitle">
            <el-table-column :prop="item.StrColumId" :label="item.StrColumName" :key="index" width="200" align="center">
              <template slot-scope="scope">
                <div class="tableEditInput" v-if="
                    scope.row.isEdit &&
                    scope.row.EditName == scope.column.property
                  ">
                  <el-input v-model="qdata[item.StrColumId]" :id="scope.row.IntExcelLine + scope.column.id" @blur="editEmployee(scope.row, scope.column)"></el-input>
                </div>
                <div v-if="
                    !scope.row.isEdit ||
                    scope.row.EditName != scope.column.property
                  ">
                  {{ scope.row[item.StrColumId] }}
                </div>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div class="block">
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page.sync="currentPage3" :page-size="pagecount" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager, next, jumper" :total="this.totalcount"></el-pagination>
        </div>
      </div>
    </div>

    <div class="dialog">
      <!-- 修改身份证 -->
      <el-dialog :visible.sync="dialogVisibleIdCard" width="580px">
        <div class="delTitle">修改身份证号码</div>
        <div class="updateContract">
          <div class="upLeft">
            <div>身份证号码</div>
            <div class="dataSele">
              <el-input size="small" v-model.trim="idInfo.idcard"></el-input>
            </div>
          </div>
        </div>
        <div class="tips">注：<span class="point">港澳台 &nbsp;&nbsp;</span>以及 <span class="point">&nbsp;&nbsp;外籍&nbsp;&nbsp;</span>雇员请补全<span class="point">&nbsp;&nbsp;性别、出生年月&nbsp;&nbsp;</span>信息,大陆雇员不需要补充！</div>
        <div class="updateContract" style="margin-top:15px">
          <div class="upLeft">
            <div>性别</div>
            <div class="dataSele">
              <el-select v-model="idInfo.sex" clearable  slot="prepend" placeholder="请选择" filterable>
                <el-option label="男" value="1"></el-option>
                <el-option label="女" value="2"></el-option>
              </el-select>
            </div>
          </div>
          <div class="upLeft">
            <div>出生年月</div>
            <div class="dataSele">
              <el-date-picker v-model="idInfo.birth" clearable  type="date" placeholder="选择日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisibleIdCard = false">取消</button>
          <button class="search" @click="editIdCard" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import FUN from "../../fun";
import xz from "../../common";
export default {
  name: "HelloWorld",
  data() {
    return {
      //修改身份证弹窗
      dialogVisibleIdCard: false,
      tData: '',
      idInfo: {
        idcard: '',
        sex: '',
        birth: ''
      },
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }]
      },
      tableHeight: 0,
      chooseInfo: true,
      btnLoading: false,
      listLoading: false,
      remark: "",
      blacklistReason: "",
      //表头内容
      tableTitle: [],
      //下拉项目名称
      strsrvcentSel: "",
      objList: [],
      //下级人员列表(负责客服)
      subordinateList: [],
      lsdata: "",
      path: "",
      qdata: [],
      empinfo: "",
      fullscreenLoading: false,
      instname: "",
      servusrname: "",
      servcentname: "",
      custname: "",
      entid: "",
      infoPath: "",
      totalmain: "",
      inputValue: "",
      tableData: [],
      currentPage3: 1,
      bank: this.$store.state.EMP.bank,
      CityzenType: this.$store.state.EMP.CityzenType,
      //分公司
      SrvCent: this.$store.state.EMP.SrvCent,
      //合同类型
      ContractType: this.$store.state.EMP.ContractType,
      // InsuranceType: this.$store.state.EMP.InsuranceType,
      //学历水平
      eduLv: this.$store.state.EMP.eduLv,
      //民族
      nationals: this.$store.state.EMP.nationals,
      isIndeterminate: true,
      //手机号码格式是否正确
      phoneJudge: "",
      contTelJudge: "",
      qqq: 0,
      totalcount: null,
      currpage: 1,
      //错误数
      errorLength: "",
      //表头内容
      tableTitle: [],
      //导出勘误
      exportQuery: {
        pagecount: 100000,
        currpage: 1,
        status: 0,
        strexcelpath: "",
      },
      pagecount: 10,
      custNameExport: "",
      multipleSelection: [],
    };
  },
  computed: {
    // path(){
    //   return this.$store.state.EXCELPATH.excelPath
    // }
  },
  created() {
    this.calHeight();
    // console.log('hh',this.$route.query.strexcelpath)
    // this.errorLength = this.$route.query.errorlength
    this.custNameExport = this.$route.query.custname;
    this.exportQuery.strexcelpath = this.$route.query.strexcelpath;
    this.getImportFiledList();
    this.getErrorInfo();
    //下拉客服
    this.getMemberList();
    //下拉项目名称
    this.getObjList(this.strsrvcentSel);
  },
  methods: {
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
      console.log('height', this.tableHeight)
    },
    isNullDate(o) {
      // console.log('isnull',o)
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == '1900/01/01' || o == '1900-01-01T00:00:00' || o == '1900-01-01';
    },
    handleCurrentChange(val) {
      const qcurrpage = this.currpage;
      if (window.localStorage.getItem("key")) {
        this.$message({
          message: "请先保存修改过的数据",
          type: "warning",
        });
        this.currentPage3 = qcurrpage;
      } else {
        this.currpage = `${val}`;
        this.getErrorInfo();
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pagecount = parseInt(val);
      this.getErrorInfo();
    },
    //导出勘误表
    exportHandle() {
      this.btnLoading = true;
      console.log("dd", this.custNameExport, this.exportQuery);
      xz.errorCurrDataTable(this.custNameExport, this.exportQuery).then(
        (res) => {
          // console.log('导出',res)
          // if(res.status == 'ok'){
          this.$router.push({
            path: "/operationRecord",
            query: {
              custname: this.custNameExport + "|" + "勘误导出",
              isExport: true,
              showPage: 1,
              isActive: 1,
              qStstus: 1,
            },
          });
          // }else{
          //   this.$message({
          //       message: "导出错误",
          //       type: "error"
          //     })
          // }
          this.btnLoading = false;
        }
      );
    },
    //获取表头信息
    getImportFiledList() {
      const data = {
        pagecount: 1000,
        currpage: 1,
        tablename: "",
        coluname: "",
        strisfixed: "0",
      };
      xz.getImportFiledInfo(data).then((res) => {
        if (res) {
          this.tableTitle = res.data;
        }
      });
    },
    //下级人员列表
    getMemberList() {
      xz.getallEmplowertListInfo().then((res) => {
        // console.log('下级人员列表',res)
        if (res.data && Array.isArray(res.data)) {
          this.subordinateList = res.data;
        } else {
          this.subordinateList = [];
        }
      });
    },
    //下拉项目名称
    getObjList(strsrvcent) {
      xz.getsrarchinstobjlist(strsrvcent).then((res) => {
        // console.log("getApartmentList", res);
        let dataList = [];
        for (let index = 0; index < res.length; index++) {
          const apartmentData = res[index];
          if (
            apartmentData.StrObjName != "" &&
            apartmentData.StrObjName != " "
          ) {
            dataList.push({ StrObjName: apartmentData.StrObjName });
          }
        }
        // console.log("getServeList", dataList);
        this.objList = dataList;
      });
    },
    //双击单元格编辑雇员信息
    showEditInput(row, column, cell, event) {
      if (column.label == '身份证') {
        this.idInfo.idcard = row.StrIdCard;
        this.dialogVisibleIdCard = true;
        this.qdata = row;
        return
      }
      this.qdata = row;
      // row.isEdit = true;
      this.$set(row, "isEdit", true);
      this.$set(row, "EditName", column.property);
      console.log("colum", row, column, cell, event);
      console.log(row.IntExcelLine + column.id);
      setTimeout(() => {
        document.getElementById(row.IntExcelLine + column.id).focus();
        this.oldCluvalue = document.getElementById(
          row.IntExcelLine + column.id
        ).value;
      }, 0);
    },
    //修改信息(input)
    editEmployee(row, column) {
      var cluvalue = document.getElementById(row.IntExcelLine + column.id)
        .value;
      if (this.oldCluvalue == cluvalue) {
        this.$delete(row, "isEdit");
        this.$delete(row, "EditName");
        return;
      }
      if (
        column.label == "身份证有效终止时间" ||
        column.label == "身份证有效终止时间" ||
        column.label == "参保日期" ||
        column.label == "用工之日" ||
        column.label == "试用期到期日期" ||
        column.label == "劳动合同起始时间" ||
        column.label == "劳动合同到期时间" ||
        column.label == "离职日期" ||
        column.label == "实际离职日期" ||
        column.label == "工伤纠纷发生时间" ||
        column.label == "工伤纠纷结束时间"
      ) {
        var a = /^(\d{4})([-])(\d{2})([-])(\d{2})$/;
        if (!a.test(cluvalue)) {
          this.$message.error("日期格式错误！请输入正确的日期");
          this.getImprtInfo();
          // this.$delete(row, "isEdit");
          // this.$delete(row, "EditName");
          return;
        }
      }
      const data = {
        tableid: "XZ_emp_UserBase",
        excelpath: row.StrExcelPath,
        execlline: row.IntExcelLine,
        cluname: column.property,
        cluvalue: cluvalue,
      };
      xz.editEmployeeInfo2(data).then((res) => {
        if (res == true) {
          row = this.qdata;
          this.$message({
            message: "雇员信息修改成功！",
            type: "success",
          });
          window.localStorage.setItem("key", true);
          // this.getErrorInfo();
        } else {
          this.$message.error("雇员信息修改失败！");
          this.getErrorInfo();
        }
      });
      // row.showError.splice(row.showError.indexOf(column.property),1)
      // console.log('sad',column.property)
      if (column.property == "DtIcCareEdate") {
        column.property = "DtIcCareEDate";
      }
      if (row.showError.indexOf(column.property) != -1) {
        row.showError.splice(row.showError.indexOf(column.property), 1);
      }
      this.$delete(row, "isEdit");
      this.$delete(row, "EditName");
      console.log(row);
    },
    //修改身份证
    editIdCard() {
      let idcode = this.idInfo.idcard.trim();
      if (idcode) {
        if (idcode.length == 18) {
          //身份证格式校验
          // 加权因子
          var weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
          // 校验码
          var check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
          var code = idcode + "";
          var last = idcode[17]; //最后一个
          var seventeen = code.substring(0, 17);
          // ISO 7064:1983.MOD 11-2
          // 判断最后一位校验码是否正确
          var arr = seventeen.split("");
          var len = arr.length;
          var num = 0;
          for (var i = 0; i < len; i++) {
            num = num + arr[i] * weight_factor[i];
          }
          // 获取余数
          var resisue = num % 11;
          var last_no = check_code[resisue];
          var idcard_patter = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
          // 判断格式是否正确
          var format = idcard_patter.test(idcode);
          if (last === last_no && format == true) {
            this.saveIdcard(idcode)
          } else {
            this.$message.error("身份证格式错误！请核对身份证信息");
            // this.getErrorInfo();
          }
        } else {
          if (this.idInfo.sex && this.idInfo.birth) {
            if (idcode.length >= 12) { 
              this.$message({
              message: '如果是港澳台或者外籍人员，请输入正确的号码，如果是大陆雇员，请不要填性别、出生年月信息',
              showClose: true,
              type: 'error',
              duration: 5000
              })
            return
            }
            let birth = this.idInfo.birth.replace(/\-/g, "");
            let idcard = this.idInfo.idcard + '-' + birth + '-' + this.idInfo.sex;
            this.saveIdcard(idcard)
          } else {
            this.$message({
              message: '如果是港澳台或者外籍人员，请完善性别、出生年月信息，如果是大陆雇员，请输入正确的身份证号码',
              showClose: true,
              type: 'error',
              duration: 5000
            })
          }
        }
      }
    },
    //保存身份证号码
    saveIdcard(idcard) {
      const data = {
        tableid: "XZ_emp_UserBase",
        excelpath: this.qdata.StrExcelPath,
        execlline: this.qdata.IntExcelLine,
        cluname: 'StrIdCard',
        cluvalue: idcard,
      };
      xz.editEmployeeInfo2(data).then((res) => {
        if (res == true) {
          this.$message({
            message: "雇员信息修改成功！",
            type: "success",
          });
          this.getErrorInfo();
        } else {
          this.$message.error("雇员信息修改失败！");
          this.getErrorInfo();
        }
        this.dialogVisibleIdCard = false
      });
    },
    //修改手机号
    editPhone(row, column) {
      var cluvalue = document.getElementById(row.IntExcelLine + column.id)
        .value;
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (regMobile.test(cluvalue)) {
        const data = {
          tableid: "XZ_emp_UserBase",
          excelpath: row.StrExcelPath,
          execlline: row.IntExcelLine,
          cluname: column.property,
          cluvalue: cluvalue,
        };
        xz.editEmployeeInfo2(data).then((res) => {
          if (res == true) {
            row = this.qdata;
            this.$message({
              message: "雇员信息修改成功！",
              type: "success",
            });
            window.localStorage.setItem("key", true);
          } else {
            this.$message.error("雇员信息修改失败！");
            this.getErrorInfo();
          }
        });
        row.showError.splice(row.showError.indexOf(column.property), 1);
        this.$delete(row, "isEdit");
        this.$delete(row, "EditName");
      } else {
        this.$message.error("手机号码格式错误！请核对手机号码");
        this.getErrorInfo();
      }
    },
    //修改信息1(select)
    chooseEmpInfo(d) {
      this.lsdata = d;
      // console.log('d',this.lsdata)
    },
    //修改信息2(select)
    chooseEmpInfo2(row, column) {
      this.strsrvcentSel = row.StrSrvCent;
      setTimeout(() => {
        this.chooseEmpInfo3(row, column);
      }, 100);
    },
    //修改信息3(select)
    chooseEmpInfo3(row, column) {
      // console.log('d2',this.lsdata)
      if (this.lsdata) {
        const data = {
          tableid: "XZ_emp_UserBase",
          excelpath: row.StrExcelPath,
          execlline: row.IntExcelLine,
          cluname: column.property,
          cluvalue: this.lsdata,
        };
        xz.editEmployeeInfo2(data).then((res) => {
          if (res == true) {
            row = this.qdata;
            this.$message({
              message: "雇员信息修改成功！",
              type: "success",
            });
            window.localStorage.setItem("key", true);
          } else {
            this.$message.error("雇员信息修改失败！");
            this.getErrorInfo();
          }
        });
        // row.isEdit = false;
        this.$delete(row, "isEdit");
        this.$delete(row, "EditName");
      } else {
        this.$message.error("雇员信息修改失败！请重新选择！");
        this.getErrorInfo();
        this.$delete(row, "isEdit");
        this.$delete(row, "EditName");
      }
    },
    // 获取出错信息
    getErrorInfo() {
      const data = {
        pagecount: this.pagecount,
        currpage: this.currpage,
        status: 0,
        strexcelpath: this.$route.query.strexcelpath,
        // strexcelpath:'excel/A16F1DBC-E843-4277-948E-467DE525C97A/E20210206191339108.xlsx'
        // strexcelpath:'excel/025B0E45-3F17-424D-A9C3-7309A9E388E3/E20210222165817015.xlsx'
      };
      this.listLoading = true;
      // const delInfo = [];
      xz.getErrorInfo(data).then((res) => {
        console.log("出错信息", res);
        let i = 1 + (this.currpage - 1) * 10;
        if (res.data && res.data.length > 0) {
          res.data.forEach((l) => {
            l.DtEntryBdate
              ? (l.DtEntryBdate = l.DtEntryBdate.substring(0, 10))
              : "-";
            l.DtProbationEdate
              ? (l.DtProbationEdate = l.DtProbationEdate.substring(0, 10))
              : "-";
            l.DtContractBtime
              ? (l.DtContractBtime = l.DtContractBtime.substring(0, 10))
              : "-";
            l.DtContractTime
              ? (l.DtContractTime = l.DtContractTime.substring(0, 10))
              : "-";
            l.DtDepartureDate
              ? (l.DtDepartureDate = l.DtDepartureDate.substring(0, 10))
              : "-";
            l.DtRealDepartureDate
              ? (l.DtRealDepartureDate = l.DtRealDepartureDate.substring(0, 10))
              : "-";
            l.DtInjuryBdate
              ? (l.DtInjuryBdate = l.DtInjuryBdate.substring(0, 10))
              : "-";
            l.DtInjuryEdate
              ? (l.DtInjuryBdate = l.DtInjuryEdate.substring(0, 10))
              : "-";
            l.DtInsuranceDate
              ? (l.DtInsuranceDate = l.DtInsuranceDate)
              : "-";
            l.DtInjuryEdate
              ? (l.DtInjuryEdate = l.DtInjuryEdate.substring(0, 10))
              : "-";
            l["num"] = i++;
            // if(window.localStorage.getItem('del')){
            //   console.log('aa',window.localStorage.getItem('del'))
            //   window.localStorage.getItem('del').forEach(element => {
            //   if(element.StrExcelPath==l.StrExcelPath){
            //     if(element.IntExcelLine==l.IntExcelLine){
            //       l['showdel'] = true;
            //     }
            //   }
            // });
            // }
          });
          var arr;
          var arr2;
          res.data.forEach((j) => {
            this.$set(j, "showError", []);
            arr = j.innerOtherinf.split("|");
            // console.log('qq',arr)
            arr.forEach((k) => {
              arr2 = k.split(":");
              j.showError.push(arr2[1], { reason: arr2[3] });
              // console.log('q2',l.showError.indexOf(arr2[1]))
            });
          });
          console.log("list", res.data);
          this.tableData = res.data;
          this.showError();
          this.totalcount = parseInt(res.totalcount);
          // this.listLoading = false;
          this.getPsInfo();
          //  this.judgePhone();
        } else {
          this.custNameExport = "";
          this.tableData = [];
          this.totalcount = 0;
        }
        this.listLoading = false;
      });
    },
    //处理错误数据
    showError() {
      var arr;
      var arr2;
      this.tableData.forEach((l) => {
        this.$set(l, "showError", []);
        // this.$set(l,"reason",[])
        arr = l.innerOtherinf.split("|");
        // console.log('qq',arr)
        arr.forEach((k) => {
          arr2 = k.split(":");
          arr2[1] = arr2[1].replace(arr2[1][0], arr2[1][0].toUpperCase());
          l.showError.push(arr2[1], { reason: arr2[3] });
          var rea = arr2[2] + ":" + arr2[3];
          if (l.reason) {
            l.reason = l.reason + "；" + rea;
          } else {
            l["reason"] = rea;
          }
          // console.log('q2',arr2[1])
        });
      });
      console.log("list", this.tableData);
    },
    //获取出生年月、性别、年龄
    getPsInfo() {
      this.tableData.forEach((l) => {
        if (l.StrIdCard) {
          if (l.StrIdCard.length == 18) {
            let idcode = l.StrIdCard;
            console.log('idcode', idcode)
            // 加权因子
            let weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2,];
            // 校验码
            let check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
            let code = idcode + "";
            let last = idcode[17].toUpperCase(); //最后一个
            let seventeen = code.substring(0, 17);
            // ISO 7064:1983.MOD 11-2
            // 判断最后一位校验码是否正确
            let arr = seventeen.split("");
            let len = arr.length;
            let num = 0;
            for (let i = 0; i < len; i++) {
              num = num + arr[i] * weight_factor[i];
            }
            // 获取余数
            var resisue = num % 11;
            var last_no = check_code[resisue];

            // 格式的正则
            // 正则思路
            // var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
            var idcard_patter = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
            // 判断格式是否正确
            var format = idcard_patter.test(idcode);
            var idcardJudge = null;
            if (last === last_no && format == true) {
              idcardJudge = "true";
            } else {
              idcardJudge = "false";
            }

            // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码

            //获取出生年月、性别、年龄
            let myDate = new Date();
            let month = myDate.getMonth() + 1;
            let day = myDate.getDate();
            let iden = idcode;
            let sexnum = null;
            let sex = null;
            let birth = null;
            let age = 0;
            age = myDate.getFullYear() - iden.substring(6, 10) - 1;
            sexnum = iden.substring(16, 17);
            if (sexnum % 2 === 0) {
              sex = "女";
            } else {
              sex = "男";
            }
            birth =
              iden.substring(6, 10) +
              "-" +
              iden.substring(10, 12) +
              "-" +
              iden.substring(12, 14);
            if (
              iden.substring(10, 12) < month ||
              (iden.substring(10, 12) == month && iden.substring(12, 14) <= day)
            )
              age++;
            l["birth"] = birth;
            l["sex"] = sex;
            l["age"] = age;
            l["idcardJudge"] = idcardJudge;
          } else {
            let count = this.searchChar(l.StrIdCard);
            let arr = [];
            if (count == 0) {
              l["birth"];
              l["sex"];
              l["age"];
              l["idcardJudge"] = 'false';
            } else if (count == 2) {
              l["idcardJudge"] = 'true';
              arr = l.StrIdCard.split('-')
              console.log('arr=', arr)
              l["StrIdCard"] = arr[0];
              let sex = arr[2] == '1' ? '男' : '女';
              let birth = arr[1].split('');
              birth.splice(4, 0, '-');
              birth.splice(7, 0, '-');
              birth = birth.join("");
              let myDate = new Date();
              let month = myDate.getMonth() + 1;
              let day = myDate.getDate();
              let age = myDate.getFullYear() - arr[1].substring(0, 4) - 1;
              if (
                arr[1].substring(4, 6) < month ||
                (arr[1].substring(4, 6) == month && arr[1].substring(6, 8) <= day)
                )
                age++;
              l["birth"] = birth;
              l["sex"] = sex;
              l["age"] = age;
            } else {
              l["idcardJudge"] = 'false';
            }
          }
        }
      });
    },
    //判断'-'出现几次
    searchChar(str) {
      let count = 0;
      let origialLength = str.length;
      str = str.replace(/\-/g, "");
      let newLength = str.length;
      count = origialLength - newLength;
      return count;
    },
    //判断手机号码格式
    judgePhone() {
      this.tableData.forEach((l) => {
        const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
        if (regMobile.test(l.StrPhoneNum)) {
          this.phoneJudge = "true";
        } else {
          this.phoneJudge = "false";
        }
        l["judgePhone"] = this.phoneJudge;
        if (regMobile.test(l.StrContTel)) {
          this.contTelJudge = "true";
        } else {
          this.contTelJudge = "false";
        }
        l["contTelJudge"] = this.contTelJudge;
      });
    },
    //选择行
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log('val', val)
      // if (val.length > 0) {
      //   val.forEach((element) => {
      //     this.multipleSelection.push({
      //       excelpath: element.StrExcelPath,
      //       execlline: element.IntExcelLine,
      //     });
      //     if (element.idcardJudge == "false") {
      //       this.chooseInfo = false;
      //     }else{
      //       this.chooseInfo = true;
      //     }
      //   });
      // } else {
      //   this.multipleSelection = [];
      // }
      console.log('mul', this.multipleSelection, this.chooseInfo)
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0;
    },
    //强制入库
    putStorage() {
      this.chooseInfo = true;
      let info = [];
      if (this.multipleSelection.length > 0) {
        this.multipleSelection.forEach((element) => {
          info.push({
            excelpath: element.StrExcelPath,
            execlline: element.IntExcelLine,
          });
          if (element.idcardJudge == "false") {
            this.chooseInfo = false;
          }
        });
      } else {
        info = [];
      }
      // console.log('info',info,this.chooseInfo)
      const odata = {
        tableid: "XZ_emp_UserBase",
        datainf: info
      }
      if (this.isNull(info)) {
        this.$message({
          message: '请选择要入库的数据',
          type: 'warning'
        });
        return false
      } else {
        if (this.chooseInfo) {
          xz.putStorage(odata).then(res => {
            this.$message({
              message: '正在入库中，入库可能会有延迟，请稍等',
              type: 'warning'
            });
            window.localStorage.removeItem('key');

            let _this = this
            setTimeout(function () {
              _this.getErrorInfo();
              _this.$store.commit("getLeftNum");
            }, 2000);
          })
        } else {
          this.$message.error("选中的数据中有身份证格式错误的或者港澳台、外籍人员信息未补充完整的，请修改后再入库")
        }
      }
    },
    columnStyle({ row }) {
      if (row.showdel) {
        return "text-decoration:line-through";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.errorShow {
  background: rgb(255, 67, 98);
}
.topOperation .exportButton {
  height: 32px;
  padding: 5px 15px;
  margin-right: 10px;
  border-radius: 5px;
  background-color: #19bd92;
  border: 1px dashed #19bd92;
  color: #fff;
}
:focus {
  outline: 0;
}
.top-right {
  display: flex;
  align-items: center;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}

.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  position: relative;
  top: 5px;
  left: 0;
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tips {
  margin-top: 20px;
  color: red;
}
.point {
  font-weight: 600;
}
</style>


<style >
.customerRosterTable3 .el-table td {
  padding: 8px 0;
}
.customerRosterTable3 .el-table th {
  padding: 12px 0;
}

.el-popper[x-placement^="bottom"] {
  margin-top: 5px;
}

.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}
.searchArea {
  margin-left: 20px;
  display: flex;
  flex-direction: row;
  position: relative;
}
.searchArea .el-select .el-input {
  height: 30px;
  width: 130px;
  border-right: none;
}
.searchArea .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.input-with-select {
  width: 430px;
}
.searchArea .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.searchArea .el-input__icon {
  line-height: 30px;
}
.drop-downMenu .el-dropdown .el-dropdown-link {
  cursor: pointer;
}
.direction .el-button {
  padding: 8px;
}
.dialog .el-dialog__header {
  padding: 0;
}
.dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.editInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.editInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.dialog .inputs {
  flex-wrap: wrap;
}
.dialog .el-drawer__body {
  overflow-y: scroll;
}
.fieldBox .el-checkbox__label {
  width: 56px;
  margin-bottom: 10px;
}
.storageInput .el-input--small .el-input__inner {
  width: 368px;
  height: 32px;
}
.storageInput .el-input--small {
  width: 360px;
}
.storageArea .upload-demo {
  height: 32px;
}
.storageArea .el-button--primary {
  background-color: #fff;
  color: #000;
  border-color: #ccc;
}
.el-button--primary:focus,
.el-button--primary:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.storageArea .el-button {
  padding: 9px 15px;
}
.el-drawer__body span:focus {
  outline: 0 !important;
}
.dialog .el-tabs--border-card > .el-tabs__content {
  max-height: 200px;
  overflow-y: scroll;
}
.dialog .el-card__body {
  max-height: 208px;
  overflow-y: scroll;
}
.tagArea .el-tag + .el-tag {
  margin-left: 10px;
}
.tagArea .el-checkbox_input.is-focus .el-checkbox_inner {
  border-color: #19bd92;
}
.tagArea .el-checkbox__input.is-checked .el-checkbox__inner,
.tagArea .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #19bd92;
  border-color: #19bd92;
}
.tagArea .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #19bd92;
}
.tagArea .el-checkbox__inner:hover {
  border-color: #19bd92;
}
.tagArea .el-tag--plain.el-tag--success {
  color: #19bd92;
}
.tagArea
  .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:not(.is-disabled):hover {
  color: #19bd92;
}
.tagArea .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #19bd92;
}
.tableEditInput .el-input__inner {
  height: 25px;
  line-height: 25px;
  text-align: center;
  padding: 0;
  font-size: 13px;
}
.tableEditInput .el-input__icon {
  line-height: 25px;
}
.el-select-dropdown__item.selected {
  color: #19bd92 !important;
}
</style>